// Hook TanStack Query — profil SPA du user courant (GET /api/auth/me).
// Le SPA s'en sert pour NE PAS AFFICHER un shell qu'il devra retirer. Ce n'est
// pas une autorisation : voir `resolveAccessGate` (src/lib/resolveAccessGate.ts).
//
// Forme MESUREE (apps/admin/server/routes/authMe.ts, 2026-09-24) : differente du
// GET /api/me de inv/hub/ug — le role vit dans `appRoles`, resolu cote serveur en
// Systeme C (ug.UserCompanyBcRoles, bc_key ADM ; corporate => ADMIN).
import { useQuery } from '@tanstack/react-query';
import { api } from '@gs/api-client';

export type SystemCRole = 'UTILISATEUR' | 'GESTIONNAIRE' | 'ADMIN';

export interface AdminMe {
  name: string;
  email: string;
  /** Un element par app servie par ce backend ; `admin` absent = aucun role ADM. */
  appRoles: { appKey: string; role: SystemCRole }[];
  allowedServicePoints: string[];
}

export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: ['admin', 'me'],
    queryFn: () => api.get<AdminMe>('/api/auth/me'),
    enabled,
    // Un refus d'acces est un ETAT stable, pas une erreur transitoire : zero
    // retry automatique. L'ecran unverifiable propose un refetch MANUEL.
    retry: false,
  });
}
